import React from "react"

import StripePaymentMethod from "./StripePaymentMethod"

export default function StripePaymentMethodsList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    methods,
    selectedMethod,
    onPaymentMethodSelected,
    onPaymentMethodDeleted,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderNoMethods() {
    return (
      <div className="item default">
        {I18n.t("cart_summary.credit_cards.no_credit_cards_present")}
      </div>
    )
  }

  function renderMethods() {
    return (
      <div>
        {methods.map((method, index) => {
          return (
            <StripePaymentMethod
              key={index}
              isSelected={method.id === selectedMethod}
              method={method}
              onSelect={onPaymentMethodSelected}
              onDelete={onPaymentMethodDeleted}
              canBeDeleted={true || methods.length > 1}
            />
          )
        })}
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------
  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <p className="fr-p2 fr-normal">
            {I18n.t("cart_summary.credit_cards.choose_a_card")}
          </p>
        </div>
      </div>
      <div className="stripe-payment-methods">
        {methods.length > 0 ? renderMethods() : renderNoMethods()}
      </div>
    </>
  )
}
